// import MyOrders from '@vue-storefront/core/compatibility/components/blocks/MyAccount/MyOrders'
import onBottomScroll from '@vue-storefront/core/mixins/onBottomScroll'
import axios from 'axios'
import i18n from '@vue-storefront/i18n'
import config from 'config'

export default {
  name: 'UserInvoices',
  mixins: [onBottomScroll],
  data () {
    return {
      pagination: {
        perPage: 100,
        current: 1,
        enabled: false
      },
      lazyLoadOrdersOnScroll: true
    }
  },
  computed: {
    invoices () {
      
      let items = this.$store.state.user.invoices && this.$store.state.user.invoices.results ? this.$store.state.user.invoices.results : []
      if (this.lazyLoadOrdersOnScroll) {
        items = items.slice(0, (this.pagination.perPage + 1) * this.pagination.current)
      }
      return items            
    },
    isInvoicesListEmpty () {
      return this.$store.state.user.invoices && this.$store.state.user.invoices.results && this.$store.state.user.invoices.results.length < 1
    }
  },
  methods: {
    onBottomScroll () {
      ++this.pagination.current
    },
    async downloadInvoice (invoiceId, invoiceNr) {           
      const token = this.$store.state.user.token;
      const downloadUrl = `${config.api.url}/api/invoice/download?token=${token}&id=${invoiceId}`
      
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: this.$t('Downloading ...'),
        action1: { label: this.$t('OK') }
      });

      await axios({
          url: downloadUrl,
          method: 'GET',
          responseType: 'blob',
        }).then (response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${invoiceNr}.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
        }).catch(err => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: i18n.t(err.message),
            action1: { label: i18n.t('OK') }
          })
        }) 
      }     
  }
}
